<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">库存管理&nbsp;/&nbsp;</span>
      </div>
      <div>库存预警推送 <span class="moneys fontSize14" v-if="enableSwitchFlag">（当产品库存数量低于预警值时，此产品库存查询预警栏将显示缺货。）</span></div>
    </div>
    <div class="page-head">
      <div class="mains-content br10">
        <div class="pltr16">库存预警开关 <el-switch v-model="enableSwitchFlag" active-color="#13ce66" inactive-color="#ececec" class="ml20" @change="switchChange"></el-switch></div>
        <div class="member-content-box" v-if="enableSwitchFlag">
          <div class="member-header">
            <div class="align-items">
              <el-select v-model="query.productType" placeholder="请选择" @change="typeChange">
                <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-select v-model="query.categoryId" placeholder="请选择" class="ml10" @change="init">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </div>
          <div class="plrb16">
            <el-table :data="list" :max-height="height - 265" @select-all="selectAll" @selection-change="selectChange" header-cell-class-name="table_header_bgcolor">
              <el-table-column type="selection" width="55" v-if="batchFlag">
              </el-table-column>
              <el-table-column prop="productName" width="auto" label="名称"></el-table-column>
              <el-table-column prop="warnMinValue" width="auto" label="预警值">
                <template slot-scope="scope">
                  <span v-if="!scope.row.flag">{{scope.row.warnMinValue}}</span>
                  <el-input v-model="scope.row.warnMinValue" maxlength="6" class="width140" @input="inputBigMethod(scope.row)" @focus="inputFocus(scope.row.warnMinValue)" v-else></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" width="80">
                <template slot-scope="scope">
                  <el-link type="primary" @click="update(scope.row)" v-if="!scope.row.flag">修改</el-link>
                  <el-link type="primary" @click="save(scope.row)" v-else>保存</el-link>
                </template>
              </el-table-column>
              <div slot="append">
                <el-row class="last-table">
                  <el-col :span="12" class="opacity0">-</el-col>
                  <el-col :span="11" :class="[batchFlag ? 'opacity1':'opacity0']">
                    <el-input v-model="batchValue" maxlength="6" :disabled="batchFlag ? false:true" class="width140"></el-input>
                  </el-col>
                  <el-col :span="1">
                    <span v-if="!batchFlag" @click="batchUpdate">批量修改</span>
                    <span v-else @click="batchSave">批量保存</span>
                  </el-col>
                </el-row>
              </div>
            </el-table>
          </div>
        </div>
        <div class="cookAllowance" v-else>
          <div class="white">
            <div>
              <div class="comingSoon-img"><img src="../../../assets/images/home/stockNoData.png" alt=""></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
export default {
  data() {
    return {
      query: {
        size: '10000',
        productType: 'product',
        categoryId: '',
      },
      height: this.$store.getters.MainHeight,
      list: [],
      enableSwitchFlag: false,
      options1: [
        {
          value: 'product',
          label: '产品'
        },
        {
          value: 'consumable',
          label: '耗材'
        }
      ],
      options2: [],
      itemList: [],
      batchValue: '',
      batchFlag: false,
      oldAmount: ''
    };
  },
  mixins: [minxin],
  components: {},
  computed: {},

  created() {
    this.getWorkConfig();
    this.init();
    this.getProductOrConsumable();
  },

  methods: {
    switchChange () {
      this.$api.post(this.$url.inventoryShopConfig.switchShopWarningConfig, {
        enableSwitchFlag: this.enableSwitchFlag,
      }).then(res => {
        if (res) {
          this.$message.success("操作成功");
          this.batchFlag = false;
          if (this.enableSwitchFlag) {
            this.init();
          }
        }
      })
    },
    getWorkConfig () {
      this.$api.get(this.$url.inventoryShopConfig.getShopWarningConfig).then(res => {
        if(res){
          this.enableSwitchFlag = res;
        }
      })
    },
    init () {
      this.list = [];
      this.itemList = [];
      this.$api.post(this.$url.inventoryShopConfig.list, this.query).then(res => {
        if (res) {
          res.map(item => {
            item.flag = false;
          });
          this.list = res;
        }
      })
    },
    getProductOrConsumable () {
      let url = this.query.productType == 'product' ? this.$url.productCategory.list:this.$url.consumableCategory.list;
      this.$api.get(url).then(res => {
        if (res) {
          this.options2 = res;
        }
      })
    },
    typeChange () {
      this.query.categoryId = "";
      this.init();
      this.getProductOrConsumable();
    },
    update (row) {
      row.flag = true;
    },
    save (row) {
      row.flag = false;
      this.itemList = [row];
      this.saveFunction();
    },
    batchUpdate () {
      this.batchFlag = true;
    },
    batchSave () {
      if (this.itemList.length == 0) return this.$message.error("请勾选数据");
      this.batchFlag = false;
      this.itemList.map(item => {
        item.warnMinValue = this.batchValue;
      })
      this.saveFunction();
    },
    saveFunction () {
      this.$api.post(this.$url.inventoryShopConfig.update, {itemFormList: this.itemList}).then(res => {
        if (res) {
          this.$message.success("操作成功");
        }
      })
    },
    selectAll (selection) {
      if (selection.length > 0) {
        this.itemList = selection;
      } else {
        this.itemList = [];
      }
    },
    selectChange (selection) {
      if (this.itemList.length == 0 && selection.length == 1) {
        this.itemList = selection;
      } else {
        if (selection.length == 0) return this.itemList = [];
        this.itemList = selection;
      }
    },
    inputBigMethod (e) {
      console.log(e)
      if (e.warnMinValue == '') {
        return;
      }
      var reg = /^[0-9]\d*$/g;
      if (!reg.test(e.warnMinValue)) {
        e.warnMinValue = this.oldAmount;
      } else {
        e.warnMinValue = Number(e.warnMinValue) + 0;
        this.oldAmount = e.warnMinValue;
      }
    },
    inputFocus (e) {
      console.log(e);
      this.oldAmount = e;
    },
    back() {
      this.$router.push("/dataList/inventory");
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  background: #fff;
  height: calc(100vh - 124px);
  .member-content-box {
    
  }
  .member-header {
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .last-table {
    padding: 5px 0;
    
  }
}
.cookAllowance {
  display: flex;
  align-items: center;
  justify-content: center;
  .comingSoon-img {
    width: 560px;
    height: auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>